export const style = {
  filterContainer: {
    width: '100%',
    // height: '48px',
    padding: '1rem',
    backgroundColor: '#FFFFFF',
    borderRadius: '10px',
    margin: '16px 0',
    zIndex: 1000,
    position: 'relative'
  },
  filterTextContainer: {
    height: '100%'
    // borderBottom: 'thin solid  #D7D7D7'
  },
  filterKeywordsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '14px',
    color: '#000000',
    height: '100%'
    // paddingBottom: '18px'
  },
  downArrow: {
    height: '14px',
    width: '14px',
    alignSelf: 'center'
  },
  clearAllBox: (isFilterSelected) => {
    return ({
      color: '#7D7D7D',
      fontSize: '10px',
      fontFamily: 'JioType-Medium',
      opacity: isFilterSelected ? '1' : '0',
      float: 'right'
    })
  },
  keywordsFlexbox: {
    display: 'grid',
    gridGap: '8px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(70px, 1fr))',
    fontSize: '12px',
    color: '#7D7D7D',
    paddingTop: '18px',
  },
  keywordsFlexboxElement: (...args) => {
    let isSelected = false
    args.forEach(element => {
      isSelected = isSelected || element
    })
    return ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '3em',
      fontSize: '12px',
      color: '#7D7D7D',
      outline: 'none',
      borderRadius: '8px',
      marginLeft: '0px',
      backgroundColor: isSelected ? 'black' : 'rgb(246, 246, 246)',
      color: isSelected ? '#FFFFFF' : '#7D7D7D'
    })
  },
  downArrowIcon: {
    marginLeft: '13px'
  },
  showOnlyAvailableSlotsFlexbox: {
    paddingTop: '19px',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '14px',
    fontFamily: 'JioType-Medium',
    color: '#000000'
  },
  filterBlocks: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '3em',
    fontSize: '12px',
    color: '#7D7D7D',
    outline: 'none',
    backgroundColor: 'rgb(246, 246, 246)',
    borderRadius: '8px',
    marginLeft: '0px'
  },
  disabledMainContainer: {
    outline: 'none',
    backgroundColor: 'rgba(239, 239, 239, 0.3)'
  },
  filterDrawerHeader: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: '#000000',
  }
}